import { forwardRef } from 'react';
import classNames from 'classnames';

import type { ActionItemButtonProps } from './action-button.type';

export const ActionItemButton = forwardRef<HTMLButtonElement, ActionItemButtonProps>(
  ({ text, Icon, icon, active, customTextColor, dataTestId, className, ...rest }, ref) => (
    <button
      type='button'
      ref={ref}
      data-testid={dataTestId}
      className={classNames(
        'flex items-center rounded-lg px-6 xs:px-4 py-4 xs:py-2 text-headline-xs xs:text-subtitle-m w-full gap-3 text-left',
        {
          'text-primary': !customTextColor,
          'fill-secondary': !active,
          'fill-secondary-active': active,
          'cursor-pointer-none pointer-events-none fill-secondary-disabled text-transparent-20': rest.disabled,
        },
        customTextColor,
        className
      )}
      {...rest}>
      {Icon && <Icon className='w-6 h-6 text-primary text-center' />}
      {icon && <span className='w-6 h-6 flex items-center justify-center'>{icon}</span>}
      {text}
    </button>
  )
);
